{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Members",
    "subtitle": "People in your company — role, team and access in one place"
  },
  "actions": {
    "invite": "Invite member",
    "promoteAdmin": "Promote to admin",
    "promoteAdminSuccess": "Member promoted to admin",
    "promoteAdminError": "Could not promote member"
  },
  "filters": {
    "searchPlaceholder": "Search name or email...",
    "role": "Role: {{value}}",
    "team": "Team: {{value}}",
    "status": "Status: {{value}}",
    "all": "All"
  },
  "col": {
    "member": "Member",
    "role": "Role",
    "team": "Team",
    "created": "Created",
    "updated": "Updated at",
    "status": "Status",
    "action": "Action"
  },
  "role": {
    "Admin": "Admin",
    "Manager": "Manager",
    "Staff": "Staff",
    "Viewer": "Viewer"
  },
  "status": {
    "Active": "Active",
    "Deactive": "Deactive",
    "Invited": "Invited"
  },
  "confirm": {
    "deactivate": {
      "title": "Deactivate this member?",
      "body": "{{name}} will lose access immediately. You can reactivate them at any time.",
      "confirm": "Deactivate",
      "cancel": "Cancel"
    }
  },
  "toast": {
    "inviteSent": "Invite sent",
    "memberUpdated": "Member updated",
    "toggleActivated": "Member activated",
    "toggleDeactivated": "Member deactivated",
    "toggleFailed": "Could not update member status"
  },
  "empty": {
    "noResults": "No members match your filters",
    "noTeam": {
      "title": "You are not assigned to a team yet",
      "body": "Contact your shop owner to be added to a team before you can see orders, products and dashboard data."
    }
  },
  "error": {
    "loadFailed": "Could not load members.",
    "retry": "Retry",
    "forbidden": {
      "title": "Access denied",
      "body": "You don't have permission to manage members. Contact your shop owner."
    }
  },
  "breadcrumb": {
    "settings": "Settings",
    "members": "Members"
  },
  "invite": {
    "title": "Invite member",
    "subtitle": "They will get an email to join your company",
    "email": "Email address",
    "emailPlaceholder": "member@company.com",
    "fullName": "Full name",
    "namePlaceholder": "Nguyen Van A",
    "role": "Role",
    "team": "Team",
    "teamPlaceholder": "Select a team",
    "noTeams": "No teams yet",
    "monthlyBudget": "Monthly budget (optional)",
    "perOrderLimit": "Per-order limit (optional)",
    "send": "Send invite",
    "sending": "Sending...",
    "permissionHint": {
      "admin": "Admin sees all teams, stores and members across the company.",
      "manager": "Manager sees orders, products and dashboard of {{team}} stores only, and can manage that team.",
      "staff": "Staff sees orders, products and dashboard of {{team}} stores only.",
      "viewer": "Viewer has read-only access to {{team}} stores."
    },
    "error": {
      "duplicate": "This email is already a member of your company.",
      "promoteOwnerOnly": "Only the shop owner can grant the Admin role.",
      "generic": "Could not send the invite. Please try again."
    }
  }
}
